// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:640px){.your-item:after{content:\"\";max-height:321px;position:absolute;top:0;right:0;height:100%;width:1px;--bg-opacity:1;background-color:#bcbec0;background-color:rgba(188,190,192,var(--bg-opacity))}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
